import { useTranslation } from '@frontend/i18n';
import { PaymentRequestActivity } from '@frontend/payments-request-activity';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { Heading } from '@frontend/design-system';
import { styles } from './styles';

export const PaymentRequestActivityCard = ({ invoiceId, locationId }: { invoiceId?: string; locationId?: string }) => {
  const { t } = useTranslation('payments');
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.max });

  return (
    <div css={styles.card}>
      <Heading level={3} css={styles.marginBottom}>
        {t('Payment Request Activity')}
      </Heading>
      <PaymentRequestActivity
        invoiceId={invoiceId ?? ''}
        locationId={locationId ?? ''}
        compactView={false}
        userChipAtBottom={isMobile}
      />
    </div>
  );
};
